import React from 'react'

interface IProps {
  label: string
  rf: string
  onClick: () => void
}

const ButtonLink = ({ label, onClick, rf }: IProps) => (
  <button
    data-rf={rf}
    type='button'
    className='csas-blue-link'
    onClick={onClick}
  >
    {label}
  </button>
)

export default ButtonLink
